<template>
	<section class="custom-item-mensagem" :class="{isProprio}">
		<div class="avatar">
			<img :src="avatar" alt="">
		</div>
		<!-- <div v-if="mensagem.substring(0,4) != '<img'">  -->

			<div v-if="mensagem.substring(0,4) == '<img'">

				<div class="texto" v-html="mensagem">{{ mensagem }}</div>
				<div class="date">{{ data }}</div>

			</div>

			<div class="mensagem" v-else>
				<div class="texto">{{ mensagem }}</div>
				<div class="date">{{ data }}</div>
			</div>
		<!-- </div> -->
		<!-- <div v-else>
			<div class="imagem" v-html="mensagem">{{ mensagem }}</div>
			<div class="date">{{ data }}</div>
		</div> -->
	</section>
</template>

<script>
export default {
	name: "ItemMensagen",

	props: [
		'avatar',
		'mensagem',
		'data',
		'isProprio',
	]
}
</script>

<style scoped>
	.custom-item-mensagem {
		display: flex;
		width: 540px;
		padding: 20px 20px 5px;
	}
	.avatar,
	.avatar img {
		width: 45px;
		height: 45px;
		/* border-radius: 50%; */
	}
	.avatar {
		margin: 10px;
	}
	.mensagem {
		flex: 1;
		background-color: #cfcfcf;
		padding: 8px;
		border-radius: 4px;
		box-shadow: -1px 3px 7px #ccc;;
	}
	.mensagem .date {
		color: teal;
		font-size: 12px;
		font-weight: bold;
	}
	.isProprio .mensagem {
		background-color: #c8c6e3;
		text-align: right;
	}
	.isProprio .avatar {
		order: 2;
	}
	.isProprio .texto {
		color: white;
	}
	.isProprio.custom-item-mensagem {
		margin-left: auto;
	}
	@media screen and (max-width: 1024px) {
		.custom-item-mensagem {
			display: flex;
			width: 340px;
			padding: 20px 20px 5px;
		}
	}

    @media screen and (max-height: 760px){
        .texto >>> img{
            width: 130%;
        }
    }
</style>
